import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { getOkrWeeklyList } from '@/api/weekly'
import { getOkrListIdByCycle } from '@/api/okr'
import { getPublishedOkr, getMyOkr } from '@/graphql/okr'
import moment from 'moment'
export default function useOkr (props, startDayOfQuarter, lastDayOfQuarter, allOrCurrent) {
  const data = ref([])
  const loadings = ref([true, true, true])
  const store = useStore()
  const selectedCycleId = computed(() => store.state.selectedCycleId)
  const okrlistId = ref(undefined)

  getOkrByCycle(selectedCycleId.value, props.userId)
  watch(selectedCycleId, cycleId => getOkrByCycle(cycleId, props.userId))

  const map = ref(undefined)
  async function getOkrByCycle (cycleId, userId) {
    if (!cycleId) {
      return
    }
    loadings.value[0] = true
    data.value = []
    getOkrListIdByCycle(cycleId, userId)
      .then(res => {
        okrlistId.value = res.id
      })
      .finally(() => {
        loadings.value[0] = false
      })
  }

  const objectives = ref([])
  watch(okrlistId, val => {
    const getOkr =
      typeof props.userId === 'undefined' ? getMyOkr : getPublishedOkr
    loadings.value[1] = true
    // const current = moment()
    getOkr(val).then(res => {
      // const objectives = res.objectives
      objectives.value = res.objectives
      data.value = []
    }).finally(() => {
      loadings.value[1] = false
    })
  })

  watch([okrlistId, startDayOfQuarter, lastDayOfQuarter], vals => {
    if (!vals[0] || !vals[1] || !vals[2]) {
      return
    }
    loadings.value[2] = true
    getOkrWeeklyList(vals[0], vals[1], vals[2]).then(weekData => {
      map.value = new Map()
      weekData.forEach(item => {
        if (!map.value.has(item.keyresultId)) {
          map.value.set(item.keyresultId, {})
        }
        map.value.get(item.keyresultId)[item.weekDate] = item
      })
    }).finally(() => {
      loadings.value[2] = false
    })
  })

  watch([objectives, allOrCurrent], () => {
    const items = []
    const current = moment()
    objectives.value.forEach((o, index) => {
      o.keyResults.filter(kr => allOrCurrent.value === 'ALL' || ((!kr.startDay || current.isAfter(moment.unix(kr.startDay))) && (!kr.finishDay || current.isBefore(moment.unix(kr.finishDay)))))
        .forEach((kr, krIndex, arr) => {
          const krItem = {
            objectiveId: o.id,
            objectiveContent: o.content,
            objectiveDescription: o.outputDesc || '[]',
            krId: kr.id,
            krContent: kr.content,
            indicator: kr.indicator,
            startDay: kr.startDay
              ? moment.unix(kr.startDay).format('YYYY-MM-DD')
              : undefined,
            endDay: kr.finishDay
              ? moment.unix(kr.finishDay).format('YYYY-MM-DD')
              : undefined,
            progress: kr.progress,
            krCount: arr.length,
            krIndex,
            stateId: kr.stateId,
            kr: kr,
            rowId: kr.id,
            // week: map.get(kr.id) || []
            week: computed(() => {
              if (!map.value.get(kr.id)) {
                map.value.set(kr.id, [])
              }
              return map.value.get(kr.id)
            })
          }
          items.push(krItem)
        })
    })
    data.value = items
  })

  return {
    data,
    loading: computed(() => loadings.value[0] || loadings.value[1] || loadings.value[2]),
    okrlistId
  }
}
